import { createContext, useContext } from "react";

import type { WindowPosition } from "./windowPositioning";

/**
 * Slot-level override for `<Window>`'s `position` prop. The floating slot uses
 * this so the rendered position follows store state even when an SDK consumer
 * forgets to forward the `position` prop into `<Window>`. Falls back to the
 * prop when unset.
 */
export const WindowPositionContext = createContext<WindowPosition | null>(null);

export function useWindowPositionOverride(): WindowPosition | null {
    return useContext(WindowPositionContext);
}
